import script from "./ModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ModalComponent.vue?vue&type=style&index=0&id=7cb3f208&lang=css"

const __exports__ = script;

export default __exports__